<template>
    <div class="list--view">            
        <div class="single--list-view single--list-view-employees">
            <vs-select
                class="selectExample"
                v-model="selectTypeRoles"
                @input="statusSelected"
            >
                <vs-select-item
                    :is-selected="item.isSelected"
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item,index) in optionsTypeRoles" />
            </vs-select>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            options: {
                type: Array,
                required: false,
                default: () => []
            },
            urlParam: {
                type: String,
                default: 'customFilter'
            }
        },
        data () {
            return {
                selectTypeRoles: this.getInitialValue(),
                optionsTypeRoles: this.options,
            }
        },
        methods: {
            getInitialValue() {
                
                const urlParams = new URLSearchParams(location.search);
                const urlValue = urlParams.get(this.urlParam);
                
                if (urlValue) {
                    
                    const matchingOption = this.options.find(opt => urlValue == opt.value);
                    
                    if (matchingOption) {
                        return matchingOption.value;
                    }
                }
                                
                const selectedOption = this.options.find(opt => opt.isSelected === true);
                return selectedOption ? selectedOption.value : (this.options[0] ? this.options[0].value : null);
            },
            statusSelected(selectedOption, id) {
                location.href = app.__vue__.addParam(this.urlParam, selectedOption);
            },
        },
    }
</script>